import { Injectable, Inject } from "@angular/core";
import { AuthHttp } from "angular2-jwt";
import { APIBase } from "./api.base";
import { Router } from "@angular/router";
import { SessionStorageService } from "../services/session-storage.service";

@Injectable()
export class ProposalsAPI extends APIBase {
  constructor(
    @Inject(AuthHttp) authHttp: AuthHttp,
    @Inject(Router) router: Router,
    @Inject(SessionStorageService) session: SessionStorageService
  ) {
    super(authHttp, router, session);

    // Entidade principal
    this.__entity = "proposals";
  }

  /**
   * getSimulation
   *
   * busca simulação
   *
   * @access public
   * @author Elian Medeiros
   * @since  05/2018
   * @param  string idProposta
   * @param  string nome
   * @param  string email
   * @return object Promise
   */
  public registerUser(idProcesso, nome, email) {
    return this._call(
      this.__entity + "/register_user/",
      {
        idProcesso: idProcesso,
        nome: nome,
        email: email,
      },
      "post"
    );
  }

  /**
   * getSimulation
   *
   * busca simulação
   *
   * @access public
   * @author Elian Medeiros
   * @since  05/2018
   * @param  string idProposta
   * @param  string nome
   * @param  string email
   * @return object Promise
   */
  public removeUserProcess(idProposta, usuarioId) {
    return this._call(
      this.__entity + "/remove_user_proposals/",
      {
        idProcesso: idProposta,
        usuarioId: usuarioId,
      },
      "post"
    );
  }

  /**
   * save
   *
   * Salva os dados
   *
   * @access public
   * @author Elian Medeiros
   * @param  object
   * @return object Promise
   */
  public save(data) {
    // substitui objeto por string
    let objSend = Object.assign({}, data);
    objSend.Simulacao = JSON.stringify(objSend.Simulacao);
    return this._call(this.__entity, objSend, data.id ? "put" : "post");
  }
  /**
   * getProcessByPropostaId
   *
   * busca processo por id
   *
   * @access public
   * @author Nicolas Aoki
   * @since  09/2019
   * @param  number idProposta
   * @return object Promise
   */
  public findPropostaByProcessoId(id) {
    return this._call(
      this.__entity + "/find_proposta_by_processoid/",
      { id: id },
      "get"
    );
  }

  public listProcessParticipants(id) {
    return this._call(this.__entity + "/participants/" + id, { id: id }, "get");
  }
}



// WEBPACK FOOTER //
// ./src/api/proposals.api.ts